import React from 'react';
import { Controller } from 'react-hook-form';

import FormErrorLabel from 'components/atoms/FormErrorLabel';
import { Checkbox, FormControlLabel } from '@mui/material';
import {
  defaultCheckboxStyle,
  StyledCheckboxBackgroundWrapper,
  StyledCheckboxLabel,
  StyledFormCheckboxWrapper,
} from 'components/molecules/FormCheckbox/styles';
import { IFormElementProps } from 'models/form';

export const FormCheckbox = ({
  name,
  id,
  label,
  control,
  errors,
  withValidation = true,
  disabled = false,
  onChange,
  style = defaultCheckboxStyle,
  labelVariant = 'body2',
  labelEnable = false,
  labelWeight = 500,
  labelColor,
  checked,
  booleanType,
}: IFormElementProps) => {
  const getValue = (value: any) => {
    if (booleanType) {
      return !!value;
    }
    return value;
  };
  return (
    <StyledFormCheckboxWrapper>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <FormControlLabel
            {...field}
            sx={{ cursor: disabled ? 'default' : 'pointer' }}
            control={
              <StyledCheckboxBackgroundWrapper
                backgroundColor={style?.backgroundColorUnChecked}
              >
                <Checkbox
                  id={id || name}
                  name={name}
                  disabled={disabled}
                  checked={checked !== undefined ? checked : getValue(field.value)}
                  sx={{
                    color: style.borderColor,
                    padding: '4px 9px',
                    height: '28px',
                    '&.Mui-checked': {
                      color: style.backgroundColorChecked,
                    },
                    '&.Mui-disabled': {
                      color: style.backgroundColorDisabled,
                    },
                  }}
                  onChange={(e) => {
                    field.onChange(e.target.checked);
                    if (onChange) {
                      onChange(e.target.checked, e.target.name);
                    }
                  }}
                />
              </StyledCheckboxBackgroundWrapper>
            }
            label={
              label !== undefined ? (
                <StyledCheckboxLabel
                  disabled={labelEnable ? false : disabled}
                  variant={labelVariant || 'body2'}
                  fontWeight={labelWeight}
                  color={labelColor}
                >
                  {label}
                </StyledCheckboxLabel>
              ) : (
                ''
              )
            }
          />
        )}
      />
      {withValidation && errors[name]?.message && (
        <FormErrorLabel label={errors[name]?.message} />
      )}
    </StyledFormCheckboxWrapper>
  );
};
